export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14288.dadf10eb.jpg";